import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import "./Booking.css";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import offersMountainguide from "../../data/offersMountainguide";
import offersAvalanches from "../../data/offersAvalanches";
import offersTravel from "../../data/offersTravel";
import { InfoOffer } from "../../components/common";
import BookingForm from "../../components/common/bookingform/BookingForm";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import emailjs from "emailjs-com";

function Booking() {
  const { id } = useParams(); // Get the id from the URL
  const location = useLocation(); // Get the state passed from the previous page
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [numOfPeople, setNumOfPeople] = useState(1);
  const [participants, setParticipants] = useState(
    Array(5).fill({ firstName: "", lastName: "" })
  ); // Store participants data
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [email, setEmail] = useState("");
  const [telefonnumber, setTelefonnumber] = useState("");
  const [wishDate, setWishDate] = useState("");
  const [remark, setRemark] = useState("");
  const [isAgbChecked, setIsAgbChecked] = useState(false);
  const [isPrivacyChecked, setIsPrivacyChecked] = useState(false);
  const [isPauschalreiseChecked, setIsPauschalreiseChecked] = useState(false); // Separate state for Pauschalreise checkbox

  const totalSteps = 4;
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.offer) {
      setSelectedOffer(location.state.offer);
    } else {
      const combinedOffers = [
        ...offersMountainguide,
        ...offersAvalanches,
        ...offersTravel,
      ];
      const offer = combinedOffers.find((offer) => offer.id === id);
      if (offer) {
        setSelectedOffer(offer);
      } else {
        console.error(`Offer with id ${id} not found`);
        navigate("/not-found");
      }
    }
  }, [id, location.state?.offer]); // Only re-run when the offer changes

  const stepNames = [
    "Reiseinformationen",
    "Persönliche Daten",
    "Übersicht",
    "Buchung",
  ];

  const getTotalPrice = () => {
    if (selectedOffer && selectedOffer.prices) {
      return selectedOffer.prices[numOfPeople] || "Preis auf Anfrage";
    }
    return "Preis auf Anfrage"; // Fallback if no price is defined
  };

  const sendEmail = () => {
    const templateParams = {
      offer: selectedOffer?.title || "Unbekannte Reise",
      numOfPeople,
      participants: participants
        .slice(0, numOfPeople)
        .map((p, index) => `Person ${index + 1}: ${p.firstName} ${p.lastName}`)
        .join(", "),
      city,
      state,
      zip,
      email,
      telefonnumber,
      wishDate: wishDate || "Kein Datum gewählt",
      remark: remark || "Keine Anmerkungen",
      agb: isAgbChecked ? "Ja" : "Nein",
      privacy: isPrivacyChecked ? "Ja" : "Nein",
      totalPrice: getTotalPrice(),
    };

    emailjs
      .send(
        "service_rjmjpkq",
        "template_j4svqro",
        templateParams,
        "_Vy4_yVElTn8uhx2H"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert(
            "Gratuliere! Deine Buchung war erfolgreich und ist auf dem Weg zu uns."
          );
          navigate("/confirmation", {
            state: { templateParams },
          });
        },
        (err) => {
          console.log("FAILED...", err);
          alert(
            "Buchung konnte nicht übermittelt werden, da ein Fehler beim Senden der E-Mail aufgetreten ist."
          );
        }
      );
  };

  // Function to render content based on step index
  const renderStepContent = (index) => {
    switch (index) {
      case 0:
        return (
          <div className="infoOffer-booking-container">
            {selectedOffer ? (
              <InfoOffer offers={selectedOffer} isBookingStage={true} />
            ) : (
              <p>Loading...</p>
            )}
          </div>
        );
      case 1:
        return (
          <div className="contact-booking-container">
            <BookingForm
              numOfPeople={numOfPeople} // Pass the current number of people to BookingForm
              setNumOfPeople={setNumOfPeople}
              participants={participants} // Pass participants and setter
              setParticipants={setParticipants}
              city={city}
              setCity={setCity}
              state={state}
              setState={setState}
              zip={zip}
              setZip={setZip}
              email={email}
              setEmail={setEmail}
              telefonnumber={telefonnumber}
              setTelefonnumber={setTelefonnumber}
              wishDate={wishDate}
              setWishDate={setWishDate}
              remark={remark}
              setRemark={setRemark}
              maxGuests={selectedOffer?.maxGuests || 5}
            />
          </div>
        );
      case 2:
        return (
          <div className="booking-overview">
            <h2>Übersicht und Bestätigung</h2>

            {/* Product details section */}
            <div className="booking-details">
              <Row>
                <Col md={6}>
                  <h4>Reise/Tour:</h4>
                </Col>
                <Col md={6}>
                  <p>{selectedOffer.title || "Name of Produkt"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>Wunschdatum:</h4>
                </Col>
                <Col md={6}>
                  <p>{wishDate || "Kein Datum gewählt"}</p>{" "}
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>Veranstaltungsort:</h4>
                </Col>
                <Col md={6}>
                  <p>{selectedOffer.place || "Ort"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>Anzahl der Personen:</h4>
                </Col>
                <Col md={6}>
                  <p>{numOfPeople || 1}</p>
                </Col>
              </Row>

              {/* Display each participant's Vorname and Nachname */}
              {participants.slice(0, numOfPeople).map((participant, index) => (
                <Row key={index}>
                  <Col md={6}>
                    <h4>Person {index + 1}:</h4>
                  </Col>
                  <Col md={6}>
                    <p>
                      {participant.firstName} {participant.lastName}
                    </p>
                  </Col>
                </Row>
              ))}

              <Row>
                <Col md={6}>
                  <h4>Adresse:</h4>
                </Col>
                <Col md={6}>
                  <p>{city || "Anschrift"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>Ort:</h4>
                </Col>
                <Col md={6}>
                  <p>{state || "Ort"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>PLZ:</h4>
                </Col>
                <Col md={6}>
                  <p>{zip || "PLZ"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>E-Mail:</h4>
                </Col>
                <Col md={6}>
                  <p>{email || "E-Mail Adresse zur Kontaktaufnahme."}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>Telefonnummer:</h4>
                </Col>
                <Col md={6}>
                  <p>{telefonnumber || "Telefonnummer zur Kontaktaufnahme."}</p>
                </Col>
              </Row>

              {/* Included Services */}
              <Row>
                <Col md={6}>
                  <h4>Inkludierte Leistungen:</h4>
                </Col>
                <Col md={6}>
                  <ul>
                    {selectedOffer.inclServices &&
                    selectedOffer.inclServices.length > 0 ? (
                      selectedOffer.inclServices.map((service, index) => (
                        <li key={index}>{service}</li>
                      ))
                    ) : (
                      <li>Keine inkludierten Leistungen</li>
                    )}
                  </ul>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>Exkludierte Leistungen:</h4>
                </Col>
                <Col md={6}>
                  <ul>
                    {Array.isArray(selectedOffer.exclServices) &&
                    selectedOffer.exclServices.length > 0 ? (
                      selectedOffer.exclServices.map((service, index) => (
                        <li key={index}>{service}</li>
                      ))
                    ) : (
                      <li>Keine exkludierten Leistungen</li>
                    )}
                  </ul>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h4>Anmerkungen:</h4>
                </Col>
                <Col md={6}>
                  <p>{remark || "keine Anmerkungen"}</p>
                </Col>
              </Row>
            </div>
          </div>
        );

      case 3:
        return (
          <div className="total-price-section">
            {/* Price breakdown (optional, only if needed) */}
            <div className="price-breakdown">
              <h5>Preisdetails</h5>
              <ul>
                <li>
                  <span>Anzahl der Personen:</span>
                  <span>{numOfPeople}</span>
                </li>
                <li>
                  <span>Preis pro Person:</span>
                  <span>€ {selectedOffer.prices[1]}</span>
                </li>
              </ul>
            </div>

            <Row className="total-price-row">
              <Col md={6}>
                <h4>Gesamtpreis:</h4>
              </Col>
              <Col md={6} className="price-amount">
                <p>€ {getTotalPrice()}</p>
              </Col>
            </Row>

            {/* Reassurance message */}
            <div className="reassurance">
              <p>
                <strong>Keine versteckten Gebühren.</strong> Alle Steuern und
                Gebühren sind im Gesamtpreis enthalten.
              </p>
            </div>

            {/* Payment */}
            <div className="payment">
              <h5>Zahlungskonditionen:</h5>
              <p>
                20% des Gesamtpreises sind nach Bestätigung des Wunschdatums von
                unserer Seite, als Anzahlung auf das unten ausgewiesene Konto
                zu überweisen. Sobald die Anzahlung am Konto eingelagt ist,
                können wir die Buchung fix für Sie bestätigen.
              </p>
              <h5>Kontoinformationen:</h5>
              <p>
                <strong>Kamikaze Travel e.U.</strong> <br />
                <strong>Bankinstitut:</strong> Salzburger Sparkasse Bank AG
                <br />
                <strong>Kontonummer:</strong> AT63 2040 4000 4357 9374
                <br />
                <strong>BIC:</strong> SBGSAT2SXXX
                <br />
                <strong>Verwendungszweck:</strong> bitte Rechnungsnummer
                angeben. <br />
              </p>

              <h5>Stornobedingungen:</h5>
              <p>
                Ein Rücktritt von der Reise ist jederzeit, gegen Entrichtung
                einer Stornogebühr möglich. <br /> Je nach Zeitpunkt des
                gewünschten Reiserücktritts, fallen folgende Stornogebühren an:
                ab dem 30. Tag vor Reiseantritt 20 %, ab dem 10. Tag vor
                Reiseantritt 70 % ab dem 2. Tag vor Reiseantritt bis zum Tag des
                Reiseantritts oder bei Nichtantritt der Reise 100 % des
                Gesamtpreises.
              </p>
            </div>

            {/* Pauschalreise Information */}
            <div className="pauschalreise-info">
              <h5>Pauschalreiserichtlinie</h5>
              <p>
                Bei der Ihnen angebotenen Kombination von Reiseleistungen
                handelt es sich um eine Pauschalreise im Sinne der Richtlinie
                (EU) 2015/2302. Daher können Sie alle EU-Rechte in Anspruch
                nehmen, die für Pauschalreisen gelten. <br />
                KaMikaze Travel e.U. trägt die volle Verantwortung für die
                ordnungsgemäße Durchführung der gesamten Pauschalreise. Zudem
                verfügt KaMikaze Travel e.U. über die gesetzlich vorgeschriebene
                Absicherung für die Rückzahlung Ihrer Zahlungen und, falls der
                Transport in der Pauschalreise inbegriffen ist, zur
                Sicherstellung Ihrer Rückbeförderung im Fall seiner Insolvenz.
                Weiterführende Informationen zu Ihren wichtigsten Rechten nach
                der Richtlinie (EU) 2015/2302 finden Sie unter
                <a
                  href="https://www.justiz.gv.at/service/pauschalreisegesetz.35f.de.html;jsessionid=1BE7A902624CB3F1B21E275CEC37F85B.s2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  diesem Link
                </a>
                . Detailierte Informationen erhalten Sie mit Ihrer
                Buchungsbestätigung.
              </p>
            </div>

            {/* Checkbox for acknowledgement */}
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="prv"
                checked={isPauschalreiseChecked}
                onChange={(e) => setIsPauschalreiseChecked(e.target.checked)}
              />
              <label htmlFor="prv">
                Ich habe meine Rechte lt. Pauschalreiserichtlinie verstanden.
              </label>
            </div>

            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="agb"
                checked={isAgbChecked}
                onChange={(e) => setIsAgbChecked(e.target.checked)}
              />
              <label htmlFor="agb">
                Ich habe die{" "}
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  AGB
                </a>{" "}
                gelesen und stimme zu.
              </label>
            </div>

            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="privacy"
                checked={isPrivacyChecked}
                onChange={(e) => setIsPrivacyChecked(e.target.checked)}
              />
              <label htmlFor="privacy">
                Ich nehme die{" "}
                <a href="/dsgvo" target="_blank" rel="noopener noreferrer">
                  Datenschutzerklärung
                </a>{" "}
                zur Kenntnis.
              </label>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  // Function to handle next step
  const handleNext = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Function to handle previous step
  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    // Define the bookingDetails object first
    const templateParams = {
      offer: selectedOffer?.title || "Unbekannte Reise",
      numOfPeople,
      participants: participants
        .slice(0, numOfPeople)
        .map((p, index) => `Person ${index + 1}: ${p.firstName} ${p.lastName}`)
        .join(", "),
      city: city || "Keine Stadt angegeben",
      state: state || "Kein Ort angegeben",
      zip: zip || "Keine PLZ angegeben",
      email: email || "Keine E-Mail angegeben",
      telefonnumber: telefonnumber || "Keine Telefonnummer angegeben",
      wishDate: wishDate || "Kein Datum gewählt",
      remark: remark || "Keine Anmerkungen",
      agb: isAgbChecked ? "Ja" : "Nein",
      privacy: isPrivacyChecked ? "Ja" : "Nein",
      prv: isPauschalreiseChecked ? "Ja" : "Nein",
      totalPrice: getTotalPrice(),
    };

    // Send email first
    sendEmail();

    // Then navigate to confirmation page with booking details
    navigate("/confirmation", {
      state: {
        templateParams, // Pass the defined bookingDetails object
      },
    });
  };

  // Function to handle abort (navigate back to the home page or previous page)
  const onAbort = () => {
    navigate(-1);
  };

  const isSubmitDisabled =
    !isAgbChecked || !isPrivacyChecked || !isPauschalreiseChecked;

  return (
    <div className="booking-container">
      <h3>Buchung</h3>

      {/* Stepper Indicator */}
      <div className="stepper-indicator">
        {Array.from({ length: totalSteps }, (_, index) => (
          <div key={index} className="step-indicator-wrapper">
            <div
              className={`step-indicator ${
                index <= currentStep ? "active" : ""
              }`}
            >
              {index + 1}
            </div>
            <div className="step-description">{stepNames[index]}</div>
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div className="stepper-panel">
        {renderStepContent(currentStep)}

        <div className="stepper-controls flex-button-group">
          {currentStep > 0 && (
            <Button
              label="Zurück"
              className="p-button-secondary"
              onClick={handlePrev}
            />
          )}

          {/* Abbrechen and Weiter buttons in the same flex group */}
          <div className="flex-right-buttons">
            <Button
              label="Abbrechen"
              className="p-button-secondary abort-button"
              onClick={onAbort}
            />

            {currentStep < totalSteps - 1 ? (
              <Button
                label="Weiter"
                className="p-button-primary"
                onClick={handleNext}
              />
            ) : (
              <Button
                label="kostenpflichtig buchen"
                className={`p-button-primary ${
                  isSubmitDisabled ? "disabled" : ""
                }`}
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Booking;
